import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { getAllPrograms } from "./programs/programIndex";
import "./ProgramsLanding.css";

// Category colour map
const CATEGORY_META = {
  "M.Tech": { label: "M.Tech", color: "#1e6ba8", bg: "rgba(30,107,168,0.12)" },
  "Online M.Tech": { label: "Online M.Tech", color: "#b83232", bg: "rgba(184,50,50,0.12)" },
  "M.Sc":   { label: "M.Sc",   color: "#16a085", bg: "rgba(22,160,133,0.12)" },
  "PhD":    { label: "PhD",    color: "#8e44ad", bg: "rgba(142,68,173,0.12)" },
};

// Simple deterministic icon per program (uses emoji as placeholder illustration)
const CATEGORY_ICONS = {
  "M.Tech": "⚙️",
  "Online M.Tech": "⚙️",
  "M.Sc":   "🔬",
  "PhD":    "🎓",
};

const CATEGORIES = ["All", "M.Tech", "Online M.Tech", "M.Sc", "PhD"];

const ProgramsLanding = () => {
  const navigate = useNavigate();
  const allPrograms = getAllPrograms();
  const [active, setActive] = useState("All");

  const filtered =
    active === "All"
      ? allPrograms
      : allPrograms.filter((p) => p.category === active);

  return (
    <div className="programs-landing">
      {/* Hero */}
      <div className="pl-hero">
        <motion.h1
          className="pl-hero-title"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          Academic Programs
        </motion.h1>
        <motion.p
          className="pl-hero-sub"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.2, duration: 0.5 }}
        >
          Explore our interdisciplinary programmes at IIT Hyderabad's Centre for
          Interdisciplinary Programs
        </motion.p>

        {/* Filter tabs */}
        <div className="pl-filter-row">
          {CATEGORIES.map((cat) => (
            <button
              key={cat}
              className={`pl-filter-btn ${active === cat ? "pl-filter-active" : ""}`}
              onClick={() => setActive(cat)}
            >
              {cat}
            </button>
          ))}
        </div>
      </div>

      {/* Card grid */}
      <div className="pl-grid">
        {filtered.map((program, idx) => {
          const meta = CATEGORY_META[program.category] || CATEGORY_META["M.Tech"];
          const icon = CATEGORY_ICONS[program.category] || "📚";
          return (
            <motion.div
              key={program.id}
              className="pl-card"
              initial={{ opacity: 0, y: 24 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: idx * 0.04, duration: 0.35 }}
              whileHover={{ y: -6, boxShadow: "0 16px 40px rgba(0,0,0,0.13)" }}
              whileTap={{ scale: 0.97 }}
              onClick={() => navigate(`/programs/${program.id}`)}
            >
              {/* Illustration area */}
              <div
                className={`pl-card-img ${
                  program.category === "Online M.Tech" ? "pl-card-img-online" : ""
                }`}
                style={{ background: meta.bg }}
              >
                <span className="pl-card-icon">{icon}</span>
                {program.category === "Online M.Tech" && (
                  <span className="pl-card-online-tag">Online</span>
                )}
              </div>

              {/* Body */}
              <div className="pl-card-body">
                <span
                  className="pl-card-badge"
                  style={{ color: meta.color, background: meta.bg }}
                >
                  {meta.label}
                </span>
                <h3 className="pl-card-title">{program.name}</h3>
                {program.description && (
                  <p className="pl-card-desc">
                    {program.description.length > 120
                      ? program.description.slice(0, 120) + "…"
                      : program.description}
                  </p>
                )}
                <div className="pl-card-cta" style={{ color: meta.color }}>
                  Learn more →
                </div>
              </div>
            </motion.div>
          );
        })}
      </div>
    </div>
  );
};

export default ProgramsLanding;
